import { render } from "./FbQuestionerOptions.vue?vue&type=template&id=4c3c5b81"
import script from "./FbQuestionerOptions.vue?vue&type=script&lang=js"
export * from "./FbQuestionerOptions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__